import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import "./Login.css";
import ROUTES from "../../docRoutes/docRoutes";
import { clearLocalSessionAction } from "../../Redux/actions/authAction";
import { resolveSloNext } from "../../utils/docGridSso";

// Single-logout stop for DocGrid. The IDP's logout chain reaches the backend
// /sso/slo-callback, which sends the browser here: the local session is
// cleared, then the chain continues to the next hop the backend approves.
const SsoSignedOut = () => {
  const dispatch = useDispatch();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const continueLogout = async () => {
      await dispatch(clearLocalSessionAction());
      const next = new URLSearchParams(window.location.search).get("next");
      const url = await resolveSloNext(next);
      window.location.replace(url || `${ROUTES.LOGIN}?authError=logged_out`);
    };

    continueLogout();
  }, [dispatch]);

  return (
    <div className="login_body">
      <div className="formWarpper">
        <div className="section-title text-center">
          <h1>Signing you out…</h1>
        </div>
      </div>
    </div>
  );
};

export default SsoSignedOut;
